import React from "react";

interface IconDisplayProps {
  Icon: any;
  style?: React.CSSProperties;
  customSize?: "XLarge" | "Large";
}

const TedIcon: React.FC<IconDisplayProps> = ({ Icon, style }) => {
  return (
    <div
      style={{
        width: 48,
        height: 48,
        ...style,
      }}
    >
      <Icon style={{ fontSize: 16, margin: "16px" }} />
    </div>
  );
};

export default TedIcon;
